import { Component, OnInit } from '@angular/core';
import { SignalSearchCriteria, SignalLoadListCriteria, SignalStatsCriteria } from 'src/app/shared/model/searchCriteria';
import { Signal, SignalStat, WordCloudItem } from 'src/app/shared/model/signal';
import { WorldWatchService } from 'src/app/shared/services/worldwatch.service';
import { DatePipe } from '@angular/common';
import { Utilities } from 'src/app/shared/utilities';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import * as Highcharts from 'highcharts';
import WordCloud from "highcharts/modules/wordcloud.js";
import { UserPreferenceService } from 'src/app/shared/services/userpreferences.service';
import { constants } from 'src/app/shared/constants';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ActivatedRoute } from '@angular/router';

WordCloud(Highcharts);


@Component({
  selector: 'app-worldwatch',
  templateUrl: './worldwatch.component.html',
  styleUrls: ['./worldwatch.component.scss']
})
export class WorldWatchComponent implements OnInit {
  // pagination
  perPage = constants.recordsPerPage.signals;
  currentPage: number;

  // data
  signals: Signal[];
  allSignals: Signal[];
  flaggedSignals: Signal[];
  signalsCount: number;
  searchCriteria: SignalSearchCriteria;
  searched: boolean;
  signalsLoaded: boolean;

  // saved searches
  savedSearches: SignalSearchCriteria[];
  searchName: string;
  hideSaveSearch: boolean;

  // user prefs
  flags: any[];
  flagRefs: string[];
  flaggingRef: string //used to stop the flapping of flags whilst waiting for update to complete

  // view
  viewType: string;
  page: string;

  // monthly stats
  monthWord: string;
  urgencyStats: SignalStat[]
  categoryStats: SignalStat[];
  totalStats: number;
  sinceLastLogin: number;

  // annuals stats
  annualSignals: Signal[];
  annualUrgencyStats: SignalStat[]
  annualCategoryStats: SignalStat[];
  annualTotalStats: number;

  // graphs
  Highcharts: typeof Highcharts = Highcharts;
  chartDataLoaded: boolean;
  annualChartDataLoaded: boolean;

  updateCategoryPie: boolean;
  catPieChartOptions = {   
    //colors: ['#1961ac', '#4bb4e6', '#bcdff7', '#007836', '#50be87', '#bbdecf'],
    colors: constants.graphSixColors,
    chart : {
       plotBorderWidth: null,
       plotShadow: false,
       backgroundColor: '#F3F3F3'
       
    },
    title : {
       text: 'Category'   
    },
    tooltip : {
       pointFormat: '<b>{point.percentage:.1f}%</b>'
    },
    plotOptions : {
       pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
             enabled: false           
          },
          showInLegend: true
       }
    },
    series : [{
       type: 'pie',
       data: [
       ]
    }],
    credits: {
      enabled: false
    }
  };

  updateUrgencyPie: boolean;
  urgPieChartOptions = {   
    //colors: ['#1961ac', '#4bb4e6', '#bcdff7', '#007836', '#50be87', '#bbdecf'],
    colors: constants.graphSixColors,
    chart : {
       plotBorderWidth: null,
       plotShadow: false,
       backgroundColor: '#F3F3F3'
    },
    title : {
       text: 'Urgency'   
    },
    tooltip : {
       pointFormat: '<b>{point.percentage:.1f}%</b>'
    },
    plotOptions : {
       pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
             enabled: false           
          },
          showInLegend: true
       }
    },
    series : [{
       type: 'pie',
       data: [
       ]
    }],
    credits: {
      enabled: false
    }
  };
  
  updateWordChart: boolean;
  wordChartOptions = {   
    colors: constants.graphColors,
    chart : {
       type: 'wordcloud',
       backgroundColor: '#F3F3F3'
    },
    title : {
       text: 'Keywords'   
    },
    series: [{
      data: [],
      type: undefined
    }],
    credits: {
      enabled: false
    }
  };

  updateAnnualCategoryPie: boolean;
  catAnnualPieChartOptions = {   
    //colors: ['#1961ac', '#4bb4e6', '#bcdff7', '#007836', '#50be87', '#bbdecf'],
    colors: constants.graphSixColors,
    chart : {
       plotBorderWidth: null,
       plotShadow: false,
       backgroundColor: '#F3F3F3'
    },
    title : {
       text: 'Category'   
    },
    tooltip : {
       pointFormat: '<b>{point.percentage:.1f}%</b>'
    },
    plotOptions : {
       pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
             enabled: false           
          },
          showInLegend: true
       }
    },
    series : [{
       type: 'pie',
       data: [
       ]
    }],
    credits: {
      enabled: false
    }
  };

  updateAnnualUrgencyPie: boolean;
  urgAnnualPieChartOptions = {   
    //colors: ['#1961ac', '#4bb4e6', '#bcdff7', '#007836', '#50be87', '#bbdecf'],
    colors: constants.graphSixColors,
    chart : {
       plotBorderWidth: null,
       plotShadow: false,
       backgroundColor: '#F3F3F3'
    },
    title : {
       text: 'Urgency'   
    },
    tooltip : {
       pointFormat: '<b>{point.percentage:.1f}%</b>'
    },
    plotOptions : {
       pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
             enabled: false           
          },
          showInLegend: true
       }
    },
    series : [{
       type: 'pie',
       data: [
       ]
    }],
    credits: {
      enabled: false
    }
  };
  
  updateAnnualWordChart: boolean;
  wordAnnualChartOptions = {   
    colors: constants.graphColors,
    chart : {
       type: 'wordcloud',
       backgroundColor: '#F3F3F3'
    },
    title : {
       text: 'Keywords'   
    },
    series: [{
      turboThreshold: 4000,
      data: [],
      type: undefined
    }],
    credits: {
      enabled: false
    }
  };

  updateStackedBarUrgency: boolean;
  loadStackedBarUrgency = false;
  stackedBarUrgencyOptions = {   
    chart: {
      type: 'column',
      backgroundColor: '#F3F3F3'
    },
    colors: constants.graphSixColors,
    //colors: ['#1961ac', '#4bb4e6', '#bcdff7', '#007836', '#50be87', '#bbdecf'],
    title: {
       align: 'right',
       text: '12 Month Trend Analysis - Urgency'
    },
    legend : {
       layout: 'horizontal',
       align: 'left',
       verticalAlign: 'top',
       floating: true,
       borderWidth: 1
    },
    xAxis:{
      categories: ["Information", "Low", "Medium", "High", "Critical"], 
      title: {
          text: null
      } 
    },
    yAxis : {
       min: 0, 
       title: {
          text: 'Signals', 
          align: 'high'
       },
       labels: {
          overflow: 'justify'
       }
    },
    tooltip : {
       valueSuffix: ' signals published'
    },
    plotOptions : {
       bar: {
          dataLabels: {
             enabled: true
          }
       },
       series: {
          stacking: 'normal'
       }
    },
    credits:{
       enabled: false
    },
    series: [
    ]
  };

  updateStackedBarCategory: boolean;
  loadStackedBarCategory = false;
  stackedBarCategoryOptions = {   
    chart: {
      type: 'column',
      backgroundColor: '#F3F3F3'
    },
    //colors: ['#1961ac', '#4bb4e6', '#bcdff7', '#007836', '#50be87', '#bbdecf'],
    colors: constants.graphSixColors,
    title: {
      align: 'right',
      text: '12 Month Trend Analysis - Category'
    },
    legend : {
       layout: 'horizontal',
       align: 'left',
       verticalAlign: 'top',
       floating: true,
       borderWidth: 1
    },
    xAxis:{
      categories: ["Advisory", "Threat", "Vulnerability", "News", "Breach", "Breaking Story", "Update", "Announcement"], 
      title: {
          text: null
       } 
    },
    yAxis : {
       min: 0, title: {
          text: 'Signals', 
          align: 'high'
       },
       labels: {
          overflow: 'justify'
       }
    },
    tooltip : {
       valueSuffix: ' signals published'
    },
    plotOptions : {
       bar: {
          dataLabels: {
             enabled: true
          }
       },
       series: {
          stacking: 'normal'
       }
    },
    credits:{
       enabled: false
    },
    series: [
    ]
  };

  updateStackedBarBreach: boolean;
  loadStackedBarBreach = false;
  stackedBarBreachOptions = {   
    chart: {
      type: 'spline',
      backgroundColor: '#F3F3F3'
    },
    //colors: ['#1961ac', '#4bb4e6', '#bcdff7', '#007836', '#50be87', '#bbdecf'],
    colors: constants.graphSixColors,
    title: {
      align: 'right',
      text: '12 Month Trend Analysis'
    },
    legend : {
       layout: 'horizontal',
       align: 'left',
       verticalAlign: 'top',
       floating: true,
       borderWidth: 1
    },
    xAxis:{ 
      categories: [], 
      title: {
          text: null
       } 
    },
    yAxis : {
       min: 0, 
       title: {
          text: 'Signals', 
          align: 'high'
       },
       labels: {
          overflow: 'justify'
       }
    },
    tooltip : {
       valueSuffix: ' signals published'
    },
    plotOptions : {
      series: {
        label: {
            connectorAllowed: false
        }
    }
    },
    credits:{
       enabled: false
    },
    series: [
    ]
  };

  // search
  advSearch = false;

  // search fields
  reference: string;
  query: string;
  category: string;
  urgency: string;
  iocQuery: string;
  publishFrom: string;
  publishTo: string;
  sort: string;
  sortOrder: number;

  datepipe: DatePipe = new DatePipe('en-GB')

  // initial page to load
  loadpage: string;

    //Export pdf
    closeResult: string;
    exportPDF: boolean = false;
    PDFName: string = ""
    fileUploaded:boolean = false;
    reportOption: string = "pdf";
    pdfAccessLevel : string = "0";

  //dropdowns
  selectedUrgencies = [];
  urgenciesData = ["Information", "Low", "Medium", "High", "Critical"];
  dropdownSettings = {
    singleSelection: false, 
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false
  };

  constructor(private worldwatchService: WorldWatchService, 
              private userprefService: UserPreferenceService, 
              private errorService: ErrorService,
              private modalService: NgbModal,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => this.loadpage = params['loadpage']);
    
    // initialise
    this.searchCriteria = new SignalSearchCriteria();
    this.signalsLoaded = false;
    this.searched = false;
    this.hideSaveSearch = false;
    this.chartDataLoaded = false;
    this.currentPage = 1;
    
    // these booleans dictate when to refresh charts
    this.updateWordChart = false;
    this.updateUrgencyPie = false;
    this.updateCategoryPie = false;

    // count the signals since last login
    this.userprefService.getUserLastLoginDate()
      .then(res => {
        this.worldwatchService.signalCountSinceLastLogin(res)
          .then(res => {
            this.sinceLastLogin = res;
          })
          .catch(err => {
            throw err;
          });
      })
      .catch(err => {
        this.handlerError(err);
      });

    // load the flags signals from the user preferences
    this.refreshSignalUserPrefs();

    // load default page for navigation
    if(!this.loadpage || this.loadpage === 'latest'){
      // load the latest signals and stats for this month
      this.page = 'signals';
      this.latestSignals()
    }else if(this.loadpage === 'lastlogin'){
      this.loadSinceLastVisit();
    }
      
  }
  exportReport(content){

    this.openModal(content)
  }
  public openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if(result == 'save'){
        this.signalsLoaded = false;
        this.exportPDF = true
        this.search()

      }

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  sortResults(field: string){
    this.currentPage = 1;

    if(this.sort === field && this.sortOrder){
      if(this.sortOrder == -1) {
        this.sortOrder = 1;
      }else{
        this.sortOrder = -1;
      }
    }else{
      this.sort = field;
      this.sortOrder = -1;
    }

    if(this.searched){
      this.search();
    }else{
      if(!this.loadpage || this.loadpage === 'latest'){
        // load the latest signals and stats for this month
        this.page = 'signals';
        this.latestSignals()
      }else if(this.loadpage === 'lastlogin'){
        this.loadSinceLastVisit();
      }
    }
  }

  /**
   * Refresh the local flagRefs and viewType variable from user preferences
   */
  refreshSignalUserPrefs(): Promise<void>{
    // load the flagged signals from user preferences
    return new Promise((resolve,reject) => {
      this.userprefService.getUserPreferences()
        .then(res => {
          if(res.flags && res.flags.signal){
            this.flagRefs = res.flags.signal;
          }else{
            this.flagRefs = [];
          }
          if(res.signalViewType){
            this.viewType = res.signalViewType;
          }else{
            this.viewType = 'list';
          }
          if(res.searches && res.searches.signal){
            this.savedSearches = res.searches.signal;
          }else{
            this.savedSearches = [];
          }

          resolve();
        })
        .catch(err => reject(err));
    });
  }

  /**
   * Search on a bunch of attributes for a signal
   */
  search() { 
    this.page = 'signals';
    this.searched = true;
    this.searchCriteria = new SignalSearchCriteria();
    this.searchCriteria.limit = this.perPage;
    this.searchCriteria.returnStub = true;

    if(this.query){
      this.searchCriteria.query = this.query;
    }
    if(this.exportPDF){
      this.searchCriteria.exportPDF = true;
      this.searchCriteria.PDFName = this.PDFName +  ' - ' + constants.accessLevels[this.pdfAccessLevel] + "." + this.reportOption;
      this.searchCriteria.pdfAccessLevel = this.pdfAccessLevel;
    }
    if(this.reference){
      this.searchCriteria.ref = this.reference;
    }
    if(this.category){
      this.searchCriteria.mainCategory = this.category;
    }
   
    if(this.selectedUrgencies.length > 0){
      this.searchCriteria.urgency = this.selectedUrgencies
    }
    if(this.publishFrom){
      this.searchCriteria.publishDateFrom = this.publishFrom;
    }
    if(this.publishTo){
      this.searchCriteria.publishDateTo = this.publishTo;
    }
    if(this.sort) {
      this.searchCriteria.sort = this.sort;
    }
    if(this.sortOrder) { 
      this.searchCriteria.sortOrder = Number(this.sortOrder);
    }
    if(this.exportPDF){
      this.exportWorldWatch()
    }
    else{
      this.signalSearch();
    }
  
  }

  /**
   * Reset all the advanced fields
   */
  reset(){
      this.reference = undefined;
      this.query = undefined;
      this.category = undefined;
      this.urgency = undefined;
      this.iocQuery = undefined;
      this.publishFrom = undefined;
      this.publishTo = undefined;
      this.sort = undefined;
      this.sortOrder = -1;
      this.searched = false;
  }

  /**
   * Add a jira reference to the user's preferences so they can flag signals
   * @param jiraRef 
   */
  flag(jiraRef: string) {
    // note which ref is being processed so we can stop user double clicking
    this.flaggingRef = jiraRef;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateFlags(constants.local.flags.signals, jiraRef, this.flagRefs.includes(jiraRef))
      .then(res => {
        this.refreshSignalUserPrefs()
          .then(res => {
            this.flaggingRef = undefined;
          })
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Toggle between grid/list view
   * @param view 
   */
  changeViewType(view: string){
    // set local variable to determine what view the user is using
    this.viewType = view;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateSingle(constants.local.views.signals, view)
      .then(res => {
        this.refreshSignalUserPrefs()
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })

  }

  /**
   * Return the signal count for urgency in a given annual time frame
   * This give totals across the entire year rather than broken down by month
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getAnnualUrgencyTotalStats(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      this.getAnnualUrgencyTotalStatsCache(pubDateFrom, pubDateTo)
        .then(res => {
          this.annualTotalStats = this.annualUrgencyStats.reduce((a,b) => a + b.count, 0);
          this.urgAnnualPieChartOptions.series[0].data = [];
          this.annualUrgencyStats.forEach(c => {
            this.urgAnnualPieChartOptions.series[0].data.push([c._id, c.count]);
          });
          this.updateAnnualUrgencyPie = true;
          resolve();
        })      
        .catch(err => {
          this.handlerError(err);
        });
      });
  }

  /**
   * Use cache if it exists, if not load from database
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getAnnualUrgencyTotalStatsCache(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      if(sessionStorage.getItem("signalAnnualUrgencyStats")){
        this.annualUrgencyStats = JSON.parse(sessionStorage.getItem("signalAnnualUrgencyStats"));
        resolve();
      }else{
        this.worldwatchService.signalUrgencyStats(pubDateFrom, pubDateTo)
        .then(res => {
          this.annualUrgencyStats = res;
        })
        .then(() => {
          sessionStorage.setItem("signalAnnualUrgencyStats", JSON.stringify(this.annualUrgencyStats));
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
      }
    });
  }

  /**
   * Return the signal count for urgency in a given monthly time frame
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getMonthlyUrgencyTotalStats(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      this.getMonthlyUrgencyTotalStatsCache(pubDateFrom, pubDateTo)
        .then(res => {
          this.totalStats = this.urgencyStats.reduce((a,b) => a + b.count, 0);
          this.processSignalsWordCloud(this.allSignals)
            .then(res => {
              let t = [];
              res.forEach(e => {
                if(e.weight > 1 && e.name.length > 2 && !constants.ignoreList.includes(e.name)){
                  t.push(e);
                }
              });
              this.wordChartOptions.series[0].data = t;
              this.updateWordChart = true;
            })
          this.urgPieChartOptions.series[0].data = [];
          this.urgencyStats.forEach(c => {
            this.urgPieChartOptions.series[0].data.push([c._id, c.count]);
          });
          this.updateUrgencyPie = true;
          resolve();
        }) 
        .catch(err => {
          this.handlerError(err);
          reject(err);
        });
    });
  }

  /**
   * Use cache if it exists, if not load from database
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getMonthlyUrgencyTotalStatsCache(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      if(sessionStorage.getItem("signalMonthUrgencyStats")){
        this.urgencyStats = JSON.parse(sessionStorage.getItem("signalMonthUrgencyStats"));
        resolve();
      }else{
        this.worldwatchService.signalUrgencyStats(pubDateFrom, pubDateTo)
        .then(res => {
          this.urgencyStats = res;
        })
        .then(() => {
          sessionStorage.setItem("signalMonthUrgencyStats", JSON.stringify(this.urgencyStats));
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
      }
    });
  }

  /**
   * Return the signal count for categories in a given time frame
   * This give totals across the entire year rather than broken down by month
   * 
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getAnnualCategoryTotalStats(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      this.getAnnualCategoryTotalStatsCache(pubDateFrom, pubDateTo)
        .then(res => {
          this.catAnnualPieChartOptions.series[0].data = [];
          this.annualCategoryStats.forEach(c => {
            this.catAnnualPieChartOptions.series[0].data.push([c._id, c.count]);
          });
          this.updateAnnualCategoryPie = true;
          resolve();
        })        
        .catch(err => {
          this.handlerError(err);
          reject(err);
        });
    });
  }

   /**
   * Use cache if it exists, if not load from database
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getAnnualCategoryTotalStatsCache(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      if(sessionStorage.getItem("signalAnnualCategoryStats")){
        this.annualCategoryStats = JSON.parse(sessionStorage.getItem("signalAnnualCategoryStats"));
        resolve();
      }else{
        this.worldwatchService.signalCategoryStats(pubDateFrom, pubDateTo)
          .then(res => {
            this.annualCategoryStats = res; 
          })
          .then(() => {
            sessionStorage.setItem("signalAnnualCategoryStats", JSON.stringify(this.annualCategoryStats));
          })
          .then(() => {
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  }

  /**
   * Return the signal count for categories in a given time frame
   * This give totals across the entire year rather than broken down by month
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getMonthlyCategoryTotalStats(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      this.getMonthlyCategoryTotalStatsCache(pubDateFrom,pubDateTo)
        .then(res => { 
          this.catPieChartOptions.series[0].data = [];
          this.categoryStats.forEach(c => {
            this.catPieChartOptions.series[0].data.push([c._id, c.count]);
          });
          this.updateCategoryPie = true;
          resolve();
        })
        .catch(err => {
          this.handlerError(err);
          reject(err);
        });
    });
  }

    /**
   * Use cache if it exists, if not load from database
   * @param pubDateFrom 
   * @param pubDateTo 
   */
  private getMonthlyCategoryTotalStatsCache(pubDateFrom: string, pubDateTo: string): Promise<void> {
    return new Promise((resolve,reject) => {
      if(sessionStorage.getItem("signalMonthCategoryStats")){
        this.categoryStats = JSON.parse(sessionStorage.getItem("signalMonthCategoryStats"));
        resolve();
      }else{
        this.worldwatchService.signalCategoryStats(pubDateFrom, pubDateTo)
          .then(res => {
            this.categoryStats = res; 
          })
          .then(() => {
            sessionStorage.setItem("signalMonthCategoryStats", JSON.stringify(this.categoryStats));
          })
          .then(() => {
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  }

  /**
   * Return the top 12 signals
   */
  latestSignals(): void {
    this.signalsLoaded = false;
    this.searched = false;
    this.currentPage = 1;

    this.searchCriteria = new SignalSearchCriteria();
    this.searchCriteria.limit = 12;
    this.searchCriteria.skip = this.perPage * (this.currentPage-1);
    this.searchCriteria.returnStub = true;

    if(this.sort) {
      this.searchCriteria.sort = this.sort;
    }
    if(this.sortOrder) { 
      this.searchCriteria.sortOrder = Number(this.sortOrder);
    }

    this.signalSearch()
      .then(res => {
        this.signalsLoaded = true;
      })
      .catch(err => {
        this.handlerError(err);
      });
  }

  /**
   * Pagination
   * @param event 
   */
  onPageChange(event): void {
    this.searchCriteria.skip = this.perPage * (this.currentPage-1);
    this.signalsLoaded = false;
    this.signalSearch()
      .then(() => this.signalsLoaded = true);
  }
  exportWorldWatch() {
    this.fileUploaded = false;
    this.worldwatchService.signalSearch(this.searchCriteria)
            .then(res => {
              this.exportPDF = false;
              this.fileUploaded = true;
              this.signalsLoaded = true;
            })
            .catch(err => {
              throw err;
            });
  }
  /** 
   * Utility method to load count of results as well as results themselves
   * Used for pagination
   */
  private signalSearch(): Promise<void> {
    return new Promise((resolve,reject) => {
      this.searchCriteria.count = true;
      let tempLimit = this.searchCriteria.limit;
      this.searchCriteria.limit = undefined;

      this.worldwatchService.signalSearch(this.searchCriteria)
        .then(res => {
          if(res && res[0]){
            this.signalsCount = res[0].matching_signals;
          }else{
            this.signalsCount = 0;
          }

          this.searchCriteria.count = false;
          this.searchCriteria.limit = tempLimit;
          this.worldwatchService.signalSearch(this.searchCriteria)
            .then(res => {
              this.allSignals = res;
              this.signals = this.allSignals;
              resolve();
            })
            .catch(err => {
              throw err;
            });
        })
        .catch(err => {
          reject();
          this.handlerError(err);
        });
    });
  }
  
  /**
   * Load all the annual analytics data for graphical presentation
   * Urgency and categories need formatting for charts
   */
  loadAnalytics(): void {

    // monthly data
    Promise.all([
      this.getMonthlyUrgencyTotalStats(Utilities.getFirstOfCurrentMonth(), Utilities.getLastOfCurrentMonth()),
      this.getMonthlyCategoryTotalStats(Utilities.getFirstOfCurrentMonth(), Utilities.getLastOfCurrentMonth())
    ])
    .then(() => {
      this.monthWord = Utilities.getCurrentMonthWord();
      this.chartDataLoaded = true;
    })

    // annual data
    this.loadAnnualSignals();

     // use session cache where possible
     if(sessionStorage.getItem("signalAnnualUrgencySeries") && sessionStorage.getItem("signalAnnualUrgencyCategories")){
      this.stackedBarCategoryOptions.xAxis.categories = JSON.parse(sessionStorage.getItem("signalAnnualUrgencyCategories"));
      this.stackedBarBreachOptions.xAxis.categories = JSON.parse(sessionStorage.getItem("signalAnnualUrgencyCategories"));
      this.stackedBarCategoryOptions.series = JSON.parse(sessionStorage.getItem("signalAnnualUrgencySeries"))
      this.stackedBarBreachOptions.series = [this.stackedBarCategoryOptions.series[1],this.stackedBarCategoryOptions.series[2],this.stackedBarCategoryOptions.series[4]];

      this.updateStackedBarBreach = true;
      this.loadStackedBarBreach = true;
      this.updateStackedBarCategory = true;
      this.loadStackedBarCategory = true;
    }else{
      this.loadAnnualCategoryMonthlyStats()
        .then(res => {
          this.stackedBarCategoryOptions.xAxis.categories = [];

          // initialise an array for each urgency
          let adv = { name: "Advisory", data: []};
          let threat = { name: "Threat", data: []};
          let vuln = { name: "Vulnerability", data: []};
          let news = { name: "News", data: []};
          let breach = { name: "Breach", data: []};
          let brkst = { name: "Breaking Story", data: []};
          let update = { name: "Update", data: []};
          let annou = { name: "Announcement", data: []};
          
          let arrayIndex = 1;
          res.forEach(dataPoint => {
            // add this months data to categories
            let x = dataPoint.name.substring(4) + "/" + dataPoint.name.substring(0,4);
            this.stackedBarCategoryOptions.xAxis.categories.push(x)
            this.stackedBarBreachOptions.xAxis.categories.push(x)

            // get this months data point for each urgency
            dataPoint.data.forEach(dp => {
              if(dp._id.mainCategory === "Advisory"){
                adv.data.push(dp.count);
              }else if(dp._id.mainCategory === "Threat"){
                threat.data.push(dp.count);
              }else if(dp._id.mainCategory === "Vulnerability"){
                vuln.data.push(dp.count);
              }else if(dp._id.mainCategory === "News"){
                news.data.push(dp.count);
              }else if(dp._id.mainCategory === "Breach"){
                breach.data.push(dp.count)
              }else if(dp._id.mainCategory === "Breaking Story"){
                brkst.data.push(dp.count);
              }else if(dp._id.mainCategory === "Update"){
                update.data.push(dp.count);
              }else if(dp._id.mainCategory === "Announcement"){
                annou.data.push(dp.count)
              }
            });

            // if there were no datapoints for this month then add a 0
            if(adv.data.length != arrayIndex){
              adv.data.push(0);
            }
            if(threat.data.length != arrayIndex){
              threat.data.push(0);
            }
            if(vuln.data.length != arrayIndex){
              vuln.data.push(0);
            }
            if(news.data.length != arrayIndex){
              news.data.push(0);
            }
            if(breach.data.length != arrayIndex){
              breach.data.push(0);
            }
            if(brkst.data.length != arrayIndex){
              brkst.data.push(0);
            }
            if(update.data.length != arrayIndex){
              update.data.push(0);
            }
            if(annou.data.length != arrayIndex){
              annou.data.push(0);
            }
            arrayIndex++;
          });

          let catSeries = [];
          catSeries.push(adv);
          catSeries.push(threat);
          catSeries.push(vuln);
          catSeries.push(news);
          catSeries.push(breach);
          catSeries.push(brkst);
          catSeries.push(update);
          catSeries.push(annou);

          this.stackedBarCategoryOptions.series = catSeries;
          this.stackedBarBreachOptions.series = [breach, vuln, threat];

          sessionStorage.setItem("signalAnnualUrgencySeries", JSON.stringify(catSeries));
          sessionStorage.setItem("signalAnnualUrgencyCategories", JSON.stringify(this.stackedBarCategoryOptions.xAxis.categories));
          
          this.updateStackedBarBreach = true;
          this.loadStackedBarBreach = true;
          this.updateStackedBarCategory = true;
          this.loadStackedBarCategory = true;
        })
        .catch(err => {
          this.handlerError(err);
        });
    }

    // use session cache where possible
    if(sessionStorage.getItem("signalAnnualCategorySeries") && sessionStorage.getItem("signalAnnualCategoryCategories")){
      this.stackedBarUrgencyOptions.xAxis.categories = JSON.parse(sessionStorage.getItem("signalAnnualCategoryCategories"));
      this.stackedBarUrgencyOptions.series = JSON.parse(sessionStorage.getItem("signalAnnualCategorySeries"))
      this.updateStackedBarUrgency = true;
      this.loadStackedBarUrgency = true;
    }else{
      this.loadAnnualUrgencyMonthlyStats()
      .then(res => {
        this.stackedBarUrgencyOptions.xAxis.categories = [];

        // initialise an array for each urgency
        let info = { name: "Information", data: []};
        let low = { name: "Low", data: []};
        let med = { name: "Medium", data: []};
        let high = { name: "High", data: []};
        let crit = { name: "Critical", data: []};
        
        let arrayIndex = 1;
        res.forEach(dataPoint => {
          // add this months data to categories
          let x = dataPoint.name.substring(4) + "/" + dataPoint.name.substring(0,4);
          this.stackedBarUrgencyOptions.xAxis.categories.push(x)

          // get this months data point for each urgency
          dataPoint.data.forEach(dp => {
            if(dp._id.signalUrgency === "Information"){
              info.data.push(dp.count);
            }else if(dp._id.signalUrgency === "Low"){
              low.data.push(dp.count);
            }else if(dp._id.signalUrgency === "Medium"){
              med.data.push(dp.count);
            }else if(dp._id.signalUrgency === "High"){
              high.data.push(dp.count);
            }else if(dp._id.signalUrgency === "Critical"){
              crit.data.push(dp.count)
            }
          });

          // if there were no datapoints for this month then add a 0
          if(info.data.length != arrayIndex){
            info.data.push(0);
          }
          if(low.data.length != arrayIndex){
            low.data.push(0);
          }
          if(med.data.length != arrayIndex){
            med.data.push(0);
          }
          if(high.data.length != arrayIndex){
            high.data.push(0);
          }
          if(crit.data.length != arrayIndex){
            crit.data.push(0);
          }
          arrayIndex++;
        });

        let urgencySeries = [];
        urgencySeries.push(info);
        urgencySeries.push(low);
        urgencySeries.push(med);
        urgencySeries.push(high);
        urgencySeries.push(crit);

        sessionStorage.setItem("signalAnnualCategorySeries", JSON.stringify(urgencySeries));
        sessionStorage.setItem("signalAnnualCategoryCategories", JSON.stringify(this.stackedBarUrgencyOptions.xAxis.categories));
        
        this.stackedBarUrgencyOptions.series = urgencySeries;
        this.updateStackedBarUrgency = true;
        this.loadStackedBarUrgency = true;
      })
      .catch(err => {
        this.handlerError(err);
      });
    }

  }

  /**
   * Return the top 10 signals
   */
  private loadAnnualSignals(): void {
    this.signalsLoaded = false;
    
    this.loadAnnualSignalsCache()
      .then(res => {
        Promise.all([
          this.getAnnualUrgencyTotalStats(Utilities.get12MonthsAgo(), Utilities.getToday()),
          this.getAnnualCategoryTotalStats(Utilities.get12MonthsAgo(), Utilities.getToday())
        ])
        .then((res) => {
          this.annualChartDataLoaded = true;
        })
      })
      .catch(err => {
        this.handlerError(err);
      });
  }

  /**
   * Load from cache if valid, else database
   */
  private loadAnnualSignalsCache(): Promise<void> {
    return new Promise((resolve,reject) => {
      if(sessionStorage.getItem("signalAnnualSignals")){
        this.annualSignals = JSON.parse(sessionStorage.getItem("signalAnnualSignals"));
        resolve();
      }else{

        this.searchCriteria = new SignalSearchCriteria();
        this.searchCriteria.updateDateFrom = Utilities.get12MonthsAgo();
        this.searchCriteria.updateDateTo = Utilities.getToday();
        this.searchCriteria.returnStub = true;
        this.worldwatchService.signalSearch(this.searchCriteria)
          .then(res => {
            this.annualSignals = res;
          })
          .then(() => {
            sessionStorage.setItem("signalAnnualSignals", JSON.stringify(this.annualSignals));
            resolve();
          })
          .catch(err => {
            this.handlerError(err);
            reject(err);
          });
      }
    });
  }

  /**
   * Returns the signal count for urgency for the last 12 months
   * This is broken down by month
   */
  private loadAnnualUrgencyMonthlyStats(): Promise<any> {
    let searchCriteria = new SignalStatsCriteria();
    searchCriteria.attributeName = constants.fields.signals.urgency;
    searchCriteria.publishDateFrom = Utilities.get12MonthsAgo();
    searchCriteria.publishDateTo = Utilities.getToday();
    return this.worldwatchService.signalMonthlyStats(searchCriteria);
  }

  /**
   * Returns the signal count for category for the last 12 months
   * This is broken down by month
   */
  private loadAnnualCategoryMonthlyStats(): Promise<any> {
    let searchCriteria = new SignalStatsCriteria();
    searchCriteria.attributeName = constants.fields.signals.category;
    searchCriteria.publishDateFrom = Utilities.get12MonthsAgo();
    searchCriteria.publishDateTo = Utilities.getToday();

    return this.worldwatchService.signalMonthlyStats(searchCriteria);
  }

  /** 
   *  Load flagged signals 
   **/
  loadFlagged(): void {
    this.page = 'flagged';
    this.searched = false;

    let loadListCriteria = new SignalLoadListCriteria();
    loadListCriteria.limit = 12;
    loadListCriteria.returnStub = true;
    loadListCriteria.jiraRefs = this.flagRefs;

    if (this.flagRefs.length === 0) {
      this.flaggedSignals = [];
      this.signals = this.flaggedSignals;
      this.signalsCount = this.signals.length;
    } else {
      this.signalsLoaded = false;

      this.worldwatchService.signalLoadList(loadListCriteria)
        .then(res => this.flaggedSignals = res)
        .then(() => {
          this.signals = this.flaggedSignals;
          this.signalsLoaded = true;
          this.signalsCount = this.signals.length;
        })
        .catch(err => {
          this.handlerError(err);
        })
    }
  }

  /**
   * Load signals created since last visit
   */
  loadSinceLastVisit(): void {
    this.page = 'signals';
    this.signalsLoaded = false;

    // since last login
    this.userprefService.getUserLastLoginDate()
      .then(res => {
        this.searchCriteria = new SignalSearchCriteria();
        this.searchCriteria.updateDateFrom = Utilities.getDateAsString(res);
        this.searchCriteria.updateDateTo = Utilities.getToday();
        if(this.sort) {
          this.searchCriteria.sort = this.sort;
        }
        if(this.sortOrder) { 
          this.searchCriteria.sortOrder = Number(this.sortOrder);
        }
        this.signalSearch()
          .then(() => this.signalsLoaded = true)
          .catch(err => {
            throw err;
          })
      })
      .catch(err => {
        this.handlerError(err);
      })

  } 

  /**
   * Process the summry of each signal into a counted word list
   * for the use in a wordcloud
   */
  private processSignalsWordCloud(signals: Signal[]): Promise<WordCloudItem[]> {
    return new Promise((resolve,reject) => {
      // concat all the summary
      let totalWords = "";
      signals.forEach(s => {
        totalWords = totalWords + ' ' + s.summary.toLowerCase() + ' ' + s.whatYouWillHear.toLowerCase();
      });

      // break down into a word count
      let lines = totalWords.split(/[,\. \(\)]+/g);
      resolve(Highcharts.reduce(lines, function (arr, word) {
            let obj = Highcharts.find(arr, function (obj) {
                return obj.name === word;
            });
            if (obj) {
                obj['weight'] += 1;
            } else {
                obj = {
                    name: word,
                    weight: 1
                };
                arr.push(obj);
            }
            return arr;
        }, [])
      )
    });
  }
  
  /**
   * Error handling forwarder, only not going direct so 
   * it allows us to add context within this module
   * @param err 
   */
  private handlerError(err){
    this.errorService.handlerError(err);
  }

  /**
   * Click through helpers from analytics page
   * @param type annual or monthly, determines date range for search
   */
  loadNew(type: string){
    this.page = 'signals';
    this.searchCriteria = new SignalSearchCriteria();
    this.searchCriteria.limit = this.perPage;
    this.advSearch = true;
    this.searchCriteria.returnStub = true;
    if(type.toLowerCase() === 'month'){
      this.publishFrom = Utilities.getFirstOfCurrentMonth();
      this.publishTo = Utilities.getLastOfCurrentMonth();
      this.searchCriteria.publishDateFrom = Utilities.getFirstOfCurrentMonth();
      this.searchCriteria.publishDateTo = Utilities.getLastOfCurrentMonth();
    }else if(type.toLowerCase() === 'annual'){
      this.publishFrom = Utilities.get12MonthsAgo();
      this.publishTo =  Utilities.getToday();
      this.searchCriteria.publishDateFrom = Utilities.get12MonthsAgo();
      this.searchCriteria.publishDateTo = Utilities.getToday();
    }

    this.signalSearch()
      .then(res => {
        this.signalsLoaded = true;
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Click through helpers from analytics page
   * @param type annual or monthly, determines date range for search
   * @param category
   */
  loadCategory(type: string, category: string){
    this.page = 'signals';
    this.category = category;
    this.advSearch = true;
    this.searchCriteria = new SignalSearchCriteria();
    this.searchCriteria.limit = this.perPage;
    this.searchCriteria.returnStub = true;
    if(type.toLowerCase() === 'month'){
      this.publishFrom = Utilities.getFirstOfCurrentMonth();
      this.publishTo = Utilities.getLastOfCurrentMonth();
      this.searchCriteria.publishDateFrom = Utilities.getFirstOfCurrentMonth();
      this.searchCriteria.publishDateTo = Utilities.getLastOfCurrentMonth();
    }else if(type.toLowerCase() === 'annual'){
      this.publishFrom = Utilities.get12MonthsAgo();
      this.publishTo =  Utilities.getToday();
      this.searchCriteria.publishDateFrom = Utilities.get12MonthsAgo();
      this.searchCriteria.publishDateTo = Utilities.getToday();
    }
    this.searchCriteria.mainCategory = category;
    this.signalSearch()
      .then(res => {
        this.signalsLoaded = true;
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Click through helpers from analytics page
   * @param type annual or monthly, determines date range for search
   * @param urgency
   */
  loadUrgency(type: string, urgency: string[]){
    this.page = 'signals';
    this.selectedUrgencies = urgency;
    this.advSearch = true;
    this.searchCriteria = new SignalSearchCriteria();
    this.searchCriteria.limit = this.perPage;
    this.searchCriteria.returnStub = true;
    if(type.toLowerCase() === 'month'){
      this.publishFrom = Utilities.getFirstOfCurrentMonth();
      this.publishTo = Utilities.getLastOfCurrentMonth();
      this.searchCriteria.publishDateFrom = Utilities.getFirstOfCurrentMonth();
      this.searchCriteria.publishDateTo = Utilities.getLastOfCurrentMonth();
    }else if(type.toLowerCase() === 'annual'){
      this.publishFrom = Utilities.get12MonthsAgo();
      this.publishTo =  Utilities.getToday();
      this.searchCriteria.publishDateFrom = Utilities.get12MonthsAgo();
      this.searchCriteria.publishDateTo = Utilities.getToday();
    }
    this.searchCriteria.urgency = urgency;
    this.signalSearch()
      .then(res => {
        this.signalsLoaded = true;
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Open modal
   * @param content 
   */
  openSearchModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'search-modal' }).result
      .then((result) => {
        if(result == 'save'){
          this.saveSearch();
        }
      }, (reason) => {
      });
  }

  /**
   * Save the search criteria in user preferences for future use
   */
  saveSearch() : void {
    let copy = (JSON.parse(JSON.stringify(this.searchCriteria)));
    delete copy.count;
    delete copy.limit;
    delete copy.skip;
    delete copy.sort;
    delete copy.sortOrder;
    copy.name = this.searchName;

    this.userprefService.userPreferencesUpdateChildArray("searches", "signal", copy, false)
      .then(res => {
        this.searchName = undefined;
        this.refreshSignalUserPrefs();
        this.hideSaveSearch = true;
      });

  }

  /**
   * Load a saved search and run
   * @param savedSearch 
   */
  loadSearch(savedSearch: SignalSearchCriteria){
    this.searchCriteria = savedSearch;
    this.signalsLoaded = false;
    this.signalSearch()
      .then(() => this.signalsLoaded = true)
      .catch(err => {
        this.handlerError(err)
      });
  }

  /**
   * Delete a saved search
   * @param event 
   * @param content 
   * @param savedSearch 
   */
  deleteSearch(event, content, savedSearch: SignalSearchCriteria): void {
    event.stopPropagation();
    this.modalService.open(content, { ariaLabelledBy: 'search-modal' }).result
      .then((result) => {
        if(result == 'delete'){
          this.userprefService.userPreferencesUpdateChildArray("searches", "signal", savedSearch, true)
            .then(res => {
              this.refreshSignalUserPrefs();
            });
        }
      }, (reason) => {
      });
  }

}
